<template>
  <div>
    <div v-if="!result">
      <Forminput
        v-if="!loading"
        @close="close"
        @saveData="saveData"
        @updateData="updateData"
        :dialogopen="modal.open"
        :inputx="modal.input"
        :showname="showname"
      ></Forminput>

      <v-tabs v-model="activeTab" slider-color="primary">
        <v-tab :key="'all'" :href="'#all'" ripple>All</v-tab>
        <v-tab v-for="(brand) in brands" :key="brand" :href="'#'+brand" ripple>{{brand}}</v-tab>
      </v-tabs>

      <v-container>
        <div>
          <div style="text-align: right">
            <v-btn @click="addliff" outline color="primary" style="border-radius: 7px">ADD LIFF</v-btn>
          </div>
        </div>
        <v-data-table
          :loading="loading"
          disable-initial-sort
          :headers="headers"
          :items="filteredData"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr @click="showResult(props.item)" style="cursor: pointer">
              <td style="padding-left: 15px;">
                <div style="width: 155px">{{ props.item.name }}</div>
              </td>
              <td class="text-xs-center">
                <div
                  v-if="props.item.photo.includes('.mp4')"
                  style="width: 40px; height:40px; border: 1px solid black; line-height: 46px"
                >
                  <v-icon>play_circle_outline</v-icon>
                </div>
                <img v-else :src="props.item.photo" style="width: 40px; height:40px" />
              </td>
              <td class="text-xs-center">{{ props.item.type }}</td>
              <td class="text-xs-center">{{ props.item.salesforce?'Yes':'No' }}</td>
              <td class="text-xs-center">{{ props.item.leadcampaign?props.item.leadcampaign:'-' }}</td>
              <td
                class="text-xs-center"
              >{{ props.item.projectinterest_code?props.item.projectinterest_code: '-' }}</td>
              <td class="text-xs-center">
                <div
                  :style="`margin-right: auto; margin-left: auto;border:1.5px solid black; width: 30px; height:30px; background-color:${props.item.background} `"
                ></div>
              </td>
              <td @click.stop="copytoClipboard(props.item.liff_url)" class="text-xs-left">
                <div style="width: 155px" class="text-truncate">
                  <a>{{ props.item.liff_url }}</a>
                </div>
              </td>
              <td class="text-xs-left">
                <span style="white-space: nowrap">
                  <v-btn
                    @click.stop="showEdit(props.item)"
                    fab
                    outline
                    color="black"
                    class="extra-small ma-1"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </v-btn>
                  <v-btn
                    @click.stop="deleteData(props.item)"
                    fab
                    outline
                    color="black"
                    class="extra-small ma-1"
                  >
                    <i class="fa fa-trash middle"></i>
                  </v-btn>
                </span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </div>
    <div v-else>
      <show-result @back="back" :data="resultdata"></show-result>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import Forminput from './Forminput.vue'
import ShowResult from './ShowResult.vue'
import copy from 'copy-to-clipboard'

export default {
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name', align: 'center' },
        { text: 'Photo', value: 'Photo', align: 'center' },
        { text: 'Type', value: 'Type', align: 'center' },
        { text: 'Salesforce', value: 'SaveSalesforce', align: 'center' },
        { text: 'LeadCampaign', value: 'leadcampaign', align: 'center' },
        { text: 'Project Interest Code', value: 'projectinterest_code', align: 'center' },
        { text: 'Background', value: 'Background', align: 'center' },
        { text: 'Liff Url', value: 'Liff Url', sortable: false, align: 'center' },
        { text: '', value: 'Setting', sortable: false, align: 'center' }
      ],
      desserts: [],
      activeTab: 'all',
      modal: {
        input: '',
        open: false
      },
      mycache: '',
      result: false,
      resultdata: '',
      loading: true
    }
  },
  components: {
    Forminput,
    ShowResult
  },
  mounted() {
    this.getanandaregisterliffurl()
  },
  computed: {
    filteredData() {
      if (this.activeTab == 'all') return this.desserts
      return this.desserts.filter(el => el.name.split(' ')[0] == this.activeTab)
    },
    showname() {
      return this.desserts.filter(el => el.name !== this.modal.input.name)
    },
    brands() {
      return [...new Set(this.desserts.map(el => el.name.split(' ')[0]))]
    }
  },
  methods: {
    copytoClipboard(data) {
      copy(data)
      this.$swal.fire({
        toast: true,
        type: 'success',
        timer: 2500,
        position: 'top-end',
        showConfirmButton: false,
        title: 'Copied to clipboard'
      })
    },
    back() {
      this.result = false
      this.resultdata = ''
    },
    showResult(data) {
      this.result = true
      this.resultdata = data
    },
    close() {
      this.modal.open = false
    },
    showEdit(data) {
      Object.assign(this.modal, { open: true, input: data })
    },
    updateData(data) {
      this.$set(
        this.desserts,
        this.desserts.findIndex(el => el.id == data.id),
        data
      )
      this.$forceUpdate()
      this.close()
    },
    saveData(data) {
      this.desserts.push(data)
      this.close()
    },
    deleteData(data) {
      let vm = this
      vm.$swal
        .fire({
          text: `คุณต้องการลบ "${data.name}" หรือไม่?`,
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            api.deleteanandaregisterliffurl(data, (error, response) => {
              if (error) console.error(error)
              if (response.responsecode == 200) {
                vm.desserts.splice(
                  vm.desserts.findIndex(el => el.id == data.id),
                  1
                )
              }
            })
          }
        })
    },
    addliff() {
      Object.assign(this.modal, {
        open: true,
        input: {
          name: '',
          photo: '',
          type: '',
          salesforce: '',
          background: '#FFF',
          projectinterest_code: ''
        }
      })
    },
    getanandaregisterliffurl() {
      var vm = this
      vm.loading = true
      api.getanandaregisterliffurl((error, response) => {
        vm.desserts = response.data.map(el => {
          return { ...el, liff_url: encodeURI(el.liff_url) }
        })
        vm.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
// .liffurl {
//   width: 150px;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }
</style>


// WEBPACK FOOTER //
// src/components/view/template/ananda/Event.vue